// simple thing for creating an empty tree
import Task from "../model/Task";
let empty = new Task("Nestly");
empty.children.push(new Task("My first item #tour"));
export default empty;
